import { Component, OnInit, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { AmplifyModelService } from '../../services/amplify-model-service.service';

import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css',
  imports: [
    RouterOutlet,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatToolbarModule
  ]
})
export class DashboardComponent implements OnInit {
  pageButtons!: any[];
  protected readonly isMobile = signal(true);

  private readonly _mobileQuery: MediaQueryList;
  private readonly _mobileQueryListener: () => void;

  constructor(
    public authenticator: AuthenticatorService,
    private router: Router,
    private ams: AmplifyModelService
  ) {
    const media = inject(MediaMatcher);

    this._mobileQuery = media.matchMedia('(max-width: 600px)');
    this.isMobile.set(this._mobileQuery.matches);
    this._mobileQueryListener = () => this.isMobile.set(this._mobileQuery.matches);
    this._mobileQuery.addEventListener('change', this._mobileQueryListener);
  }

  async ngOnInit() {
    console.log('🏠 Dashboard - Loading menu items...');
    this.pageButtons = await this.ams.getMenuLinksFromModels();
    console.log('✅ Dashboard - Menu items loaded:', this.pageButtons);
  }

  navClick(target: any) {
    console.log('will navClick to ', target);
    this.router.navigate([target.route]);
  }

  async signOut() {
    console.log('🚪 Dashboard - Signing out user...');
    try {
      // Use both sign out methods to ensure complete logout
      this.authenticator.signOut();
      await this.ams.signOut();
      console.log('✅ Dashboard - User signed out successfully');
      
      // Navigate to homepage
      await this.router.navigate(['/']);
      console.log('🏠 Dashboard - Redirected to homepage');
    } catch (error) {
      console.error('❌ Dashboard - Error signing out:', error);
      // Even if there's an error, navigate to homepage
      await this.router.navigate(['/']);
    }
  }
}